const styles = {
  link: {
    cursor: "pointer",
    textDecoration: "none",
    borderBottom: "1px solid",
    borderBottomColor: "primary.main",
  },
};
export default styles;
